import { useCallback } from 'react';

import { useChatSidebar } from '@/contexts/useChatSidebar';
import {
  PostHogEventName,
  usePostHogTracking,
} from '@/hooks/usePostHogTracking';

import type { Shortcut } from '@/components/chat/shortcutsConfig';

export const useHandleShortcutClick = () => {
  const { openChat } = useChatSidebar();
  const { trackEvent } = usePostHogTracking();

  return useCallback(
    (shortcut: Shortcut) => {
      void trackEvent(PostHogEventName.ShortcutClicked, {
        shortcut_label: shortcut.label,
        shortcut_number: shortcut.order,
      });

      openChat({ message: shortcut.prompt, newConversation: true });
    },
    [openChat, trackEvent]
  );
};
